import React from "react";

const VisionMission = () => {
  return (
    <section id="vision-mission" className="py-24 px-6 lg:px-20 bg-[#080C10]">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-['IBM_Plex_Mono'] text-[#F07023] text-xs tracking-[0.3em] uppercase">
            Our Compass
          </span>
          <h2 className="text-white text-[clamp(1.5rem,2.5vw,2.75rem)] font-[700] mt-4 leading-tight">
            Vision & Mission
          </h2>
          <div className="w-12 h-px bg-[#F07023] mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="border-t-2 border-[#F07023]/25 pt-6">
            <h3 className="text-lg font-[600] text-[#F07023] mb-3">Vision</h3>
            <p className="text-[#8892A4] leading-relaxed text-[0.95rem]">
              Making Bharat self reliant with next generation solutions through top-notch, reliable and
              accessible technology.
            </p>
          </div>
          <div className="border-t-2 border-[#F07023]/25 pt-6">
            <h3 className="text-lg font-[600] text-[#F07023] mb-3">Mission</h3>
            <p className="text-[#8892A4] leading-relaxed text-[0.95rem]">
              Deliver custom made, robust solutions to domain specific problems.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
